angular.module('agreements')
    .factory('AgreementBgt', function ($resource) {
        return $resource('crm/api/agreement/:agreementId/bgt/:id', { }, {
            'query': { method: 'GET', isArray: true },
            'get': { method: 'GET' },
            'save': { method: 'POST' },
            'update': { method: 'PUT' },
            'delete': { method: 'DELETE' },
            'revisions': {method: 'GET', url: 'crm/api/agreement/:agreementId/bgt/revisions', isArray: true},
            'createRevision': {method: 'POST', url: 'crm/api/agreement/:agreementId/bgt/revisions'},
            'publishRevision': {method: 'PUT', url: 'crm/api/agreement/:agreementId/bgt/revisions/:revisionId/publish'},
            'deleteRevision': {method: 'DELETE', url: 'crm/api/agreement/:agreementId/bgt/revisions/:revisionId'}
        });
    })
    .service('AgreementBgtService', function ($rootScope, $cookies, toastr, modals, Principal, AgreementBgt) {
        this.add = (agreementId, revisionId, totalLeft, invoiceTotal, currency) => {
            let entity = {
                agreementId: agreementId,
                revisionId: revisionId,
                totalLeft: totalLeft,
                invoiceTotal: invoiceTotal,
                currency: currency
            }
            return modals.open('app/agreements/bgt/edit-position.html', 'AgreementBgtEditPositionController', entity, {size: "sm"}, "$ctrl")
        }
        this.edit = (agreementId, revisionId, item, totalLeft, invoiceTotal, currency) => {
            let entity = {
                item: item,
                agreementId: agreementId,
                revisionId: revisionId,
                totalLeft: totalLeft,
                invoiceTotal: invoiceTotal,
                currency: currency
            }
            return modals.open('app/agreements/bgt/edit-position.html', 'AgreementBgtEditPositionController', entity, {size: "sm"}, "$ctrl")
        }
        this.delete = (agreementId, revisionId, item) => {
            return modals.confirmDelete("wybraną pozycję", () => AgreementBgt.delete({agreementId: agreementId, revisionId: revisionId, id: item.id}).$promise)
        }
    })
